// extracted by mini-css-extract-plugin
module.exports = {"short_input":"short_input--q6Fqq","large_input":"large_input--1kmB2","text_area":"text_area--2pp7C"};